/* eslint-disable @typescript-eslint/naming-convention */
export enum RecommendationEnum {
  ECONOMICAL,
  SUSTAINABLE,
  RENOVATION,
  MANUAL,
}

export enum WorkOrderOptions {
  viewDetails = 'viewDetails',
  csvDownload = 'csvDownload',
  delete = 'delete',
}

export enum WorkOrderSortHeader {
  addressInfo = 'addressInfo',
  streetlightNumber = 'streetlightNumber',
  reportedDate = 'reportedDate',
  isInsured = 'isInsured',
  damageType = 'damageType',
  status = 'status',
}

export enum ZahlerstandSortHeader {
  type = 'type',
  address = 'address',
  objectType = 'objectType',
  status = 'status',
}

export enum ScenarioTypeEnum {
  economical = '9985b9c8-e566-46f8-b4a1-33a2ea703d0f',
  sustainable = '3bda5bc9-f616-440d-8b86-531a25c81e46',
  renovation = '51a9adab-2660-4a61-8ae4-d3ae0d5f86c4',
  manual = 'CC304A34-0FB0-48F9-B297-31F826C4A180',
}

export enum Roles {
  backOffice = 'BO',
  systemAdministrator = 'SYSADMIN',
  municipalityWorker = 'MW',
  callCenterAgent = 'CCA',
  keyAccountManager = 'KAM',
  regionalStreetlightExpert = 'RSE',
  administrationAreaWorker = 'AAW',
  poDSO = 'PODSO',
  poHolding = 'POHOL',
  technicalDsoExpert = 'TDEX',
  technicalDsoEmployee = 'TDEM',
  meterPointExpert = 'MPEX',
}

export enum ExternalRoles {
  municipalityWorker = 'MW',
  administrationAreaWorker = 'AAW',
}

export enum ApplicationInsightEvent {
  clickDashboard = 'ClickDashboard',
  logout = 'Logout',
  streetlightPlannerAccess = 'StreetlightPlannerAccess',
  streetlightPlannerCancel = 'StreetlightPlannerCancel',
  streetlightPlannerSave = 'StreetlightPlannerSave',
  streetlightPlannerUpdate = 'StreetlightPlannerUpdate',
  streetlightPlannerSubmit = 'StreetlightPlannerSubmit',
  download = 'Download',
  municipalityActive = 'MunicipalityActive',
  featureActivity = 'FeatureActivity',
  contactRequest = 'ContactRequest',
  heatDataLegalConfirmation = 'HeatDataLegalConfirmation',
  heatDataDownloadNDA = 'HeatDataDownloadNDA',
  meterEntryTransmissionSuccess = 'MeterEntryTransmissionSuccess',
  meterEntryTransmissionFail = 'MeterEntryTransmissionFail',
  meterEntryDownload = 'MeterEntryDownload',
  meterEntryDownloadError = 'MeterEntryDownloadError',
  meterEntryUpload = 'MeterEntryUpload',
  meterEntryImplausible = 'MeterEntryImplausible',
  buildingTypeSave = 'BuildingTypeSave',
  videoPlay = 'VideoPlay',
  brennstellenliste = 'Brennstellenliste',
  meterObjectBuildingTypeSave = 'MeterObjectBuildingTypeSave',
  viewEfficiencyAnalysis = 'ViewEfficiencyAnalysis',
  cancelEfficiencyAnalysis = 'CancelEfficiencyAnalysis',
  deleteEfficiencyAnalysis = 'DeleteEfficiencyAnalysis',
  saveEfficiencyAnalysis = 'SaveEfficiencyAnalysis',
  errorEfficiencyAnalysis = 'ErrorEfficiencyAnalysis',
  wizardNextEventEfficiencyAnalysis = 'WizardStepEfficiencyAnalysis',
  wizardPreviousEventEfficiencyAnalysis = 'WizardPreviousEventEfficiencyAnalysis',
  heatDataActivateRequest = 'HeatDataRequest',
  zahlerstandDownload = 'ZahlerstandDownload',
  zahlerstandDownloadError = 'ZahlerstandDownloadError',
  zahlerstandGlnDsoIsEmpty = 'ZahlerstandGlnDsoIsEmpty',
  oko = 'OKO',
}

export enum DashboardModuleNames {
  energiekarte = 'Energiekarte',
  zählerstand = 'Zählerstand',
  energiedaten = 'Energiedaten',
  effizienzanalyse = 'Effizienzanalyse',
  planauskunft = 'Planauskunft',
  planauskunftLvn = 'PlanauskunftLvn',
  storungen = 'Storungen',
  co2Bilanz = 'CO2Bilanz',
  informationen = 'Informationen',
  webshop = 'Webshop',
  eeNetznavi = 'EE-Netznavi',
  lvnStreetlightManager = 'LvnStreetlightManager',
  energyReport = 'EnergyReport',
  myDocuments = 'MyDocuments',
  lieferstellenverwaltung = 'Lieferstellenverwaltung',
  kontakt = 'Kontakt',
  energiemonitor = 'Energiemonitor',
  sensordaten = 'Sensordaten',
  innoLive = 'InnoLive',
  lokalerStrommarkt = 'LokalerStrommarkt',
  energieWachter = 'EnergieWachter',
  storungmelden = 'Storungmelden',
  strabenbeleuchtungplanen = 'Strabenbeleuchtungplanen',
  brennstellenliste = 'Brennstellenliste',
  serviceReport = 'ServiceReport',
  produktkatalog = 'Produktkatalog',
  arbeitsaufträge = 'Arbeitsaufträge',
  fehlermeldungen = 'Fehlermeldungen',
  posteingang = 'Posteingang',
  eKommune = 'E-Kommune',
  meterReadingLEW = 'Zählerstand',
  snapLvn = 'Schnelle Netzanschlussprüfung LVN',
  roommonitor = 'Raummonitoring',
  energieManagementOptimum = 'EnergieManagement',
  externalApp = 'ExternalApp',
  netzinfrastruktur = 'Netzinfrastruktur',
  financeReport = 'Finanzreport',
}

export enum UserStatus {
  active = 'ACTIVE',
  activationPending = 'PENDING_ACTIVATION',
  any = 'Beliebiger Status',
  emailPending = 'PENDING_EMAIL_CONFIRMATION',
  invitationWithdrawn = 'CANCELLED_INVITATION',
  inActive = 'INACTIVE',
  null = 'NULL',
}

export enum EnergiedatenSortHeader {
  meterTypeName = 'meterTypeName',
  energyTypeName = 'energyTypeName',
  address = 'address',
  objectType = 'objectType',
  notes = 'notes',
  meterNumber = 'meterNumber',
}

export enum MeterConsumptionChartTypes {
  rlmFifteenMinute = 'Viertelstundenwerte',
  rlmHourly = 'Stundenwerte',
  rlmWeekly = 'Tageswerte (Woche)',
  rlmDaily = 'Tageswerte (Monat)',
  rlmYearly = 'Jahreswerte',
  rlmMonthly = 'Monatswerte',
  smdDaily = 'Zählerstand',
}

export enum SLPMeterConsumptionChartTypes {
  periodic = 'Abrechnungszeitraum',
  yearly = 'Jahreswerte',
}

export enum SLPMasterChartView {
  accounting = 'Abrechnungswerte',
  remoteReading = 'Messwerte',
  estimated = 'Geschätzte Messwerte',
}

export enum ChartTypes {
  bar = 'Säulendiagramm',
  line = 'Liniendiagramm',
}

export enum SLPChartYAxis {
  biDirectional = 'Verbrauch / Erzeugung [kWh]',
  consumerOnly = 'Verbrauch [kWh]',
  producerOnly = 'Erzeugung [kWh]',
}

export enum MeterType {
  slpZahler = 'MT_SLP',
  rlmZahler = 'MT_RLM',
  smdZahler = 'MT_SMD',
}

export enum LegendTextMeterType {
  SLP = 'SLP (nicht fernauslesbar)',
  RLM = 'RLM (fernauslesbar)',
  iMSys = 'iMSys (fernauslesbar)',
}

export enum ChartErrorType {
  dataEmpty = 'emptyData',
  dataLoadError = 'errorData',
}

export enum EnergyTypesName {
  gas = 'GAS',
  electricity = 'STROM',
}

export enum MeterEntryLockType {
  loading = 'loading',
  valid = 'valid',
  saved = 'saved',
  implausible = 'implausible',
  locked = 'locked',
  error = 'error',
  invalid = 'invalid',
  retry = 'retry',
}

export enum UploadStatus {
  invalid = 'invalid',
  implausible = 'implausible',
  skip = 'skip',
}

export enum MeterEntryStatusColor {
  RED = 'RED',
  YELLOW = 'YELLOW',
  BLUE = 'BLUE',
  GREEN = 'GREEN',
  GREY = 'GREY',
  WHITE = 'WHITE',
}

export enum MeterReadingSortType {
  mandatoryOverdue = 1,
  mandatoryBiDirectional = 2,
  mandatory = 3,
  inReview = 4,
  optional = 5,
  automaticReading = 6,
  locked = 99,
}

export enum ZahlerstandMeterReadingSortType {
  mandatoryOverdue = 1,
  mandatoryBiDirectional = 2,
  mandatory = 3,
  inReview = 4,
  optional = 5,
  locked = 6,
  automaticReading = 99,
}

export enum ZahlerstandSourceOfMeterReading {
  customer = 'customer',
  distributionNetworkOperator = 'distribution_network_operator',
  externalOperatorService = 'external_operator_service',
  meterOperatorService = 'meter_operator_service',
  supplier = 'supplier',
}

export enum ZahlerstandSourceOfMeterReadingDisplay {
  customer = 'Kunde',
  distributionNetworkOperator = 'Verteilnetzbetreiber',
  meterOperatorService = 'Messstellenbetreiber',
  noData = 'Keine Daten vorhanden',
  supplier = 'Lieferant',
}

export enum MeterReadingUploadSortType {
  implausible = 2,
  failed = 3,
  successful = 1,
}

export enum MeterReadingLockPeriodType {
  notLockPeriod = 1,
  inLockPeriod = 2,
  exceedLockPeriod = 3,
}

export enum MeterEntryHighestPriorityLockReason {
  alreadyRecordedReadingReason = 'LOCKED_BY_ALREADY_RECORDED_READING_REASON',
  implausibleLastReadingResult = 'LOCKED_BY_IMPLAUSIBLE_LAST_READING_RESULT',
  invalidDateRangesInRegisters = 'LOCKED_BY_INVALID_DATERANGES_IN_REGISTERS',
  meterLocked = 'METER_LOCKED',
  missingPreviousReadingResult = 'LOCKED_BY_MISSING_PREVIOUS_READING_RESULT',
  tooManyReadingResults = 'LOCKED_BY_TOO_MANY_READING_RESULTS',
}

export enum MeterEntryReadingStatus {
  locked = 'locked',
  withOpenReadingOrders = 'WITH_OPEN_READING_ORDERS',
  withoutOpenReadingOrders = 'WITHOUT_OPEN_READING_ORDERS',
}

export enum HttpStatusCodes {
  continue = 100,
  ok = 200,
  accepted = 202,
  noContent = 204,
  badRequest = 400,
  unauthorized = 401,
  forbidden = 403,
  notFound = 404,
  notAcceptable = 406,
  conflict = 409,
  unprocessableEntity = 422,
  internalServerError = 500,
  notImplemented = 501,
  badGateway = 502,
}

export enum PackageTypes {
  EXTERNAL,
  ELECTRICAL,
  INTERNAL,
  MECHANICAL,
  NA,
}

export enum SensorTypes {
  TEMPERATURE = 'TEMPERATURESENSOR',
  MOTION = 'MOTION',
  CARBONDIOXIDE = 'AIRQUALITYSENSOR', // DIOXIDESENSOR
  CARBONMONOXIDE = 'MONOXIDE',
  PARTICULATE = 'PARTICULATE',
  AIRQUALITY = 'DIOXIDESENSOR', // AIRQUALITYSENSOR
  FLUID = 'TANK',
  SPEED = 'SPEEDSENSOR',
  SMOKE = 'SMOKE',
  DOOR = 'DOOR',
  LIGHT = 'LIGHT',
  PUSH = 'PUSH',
  GPS = 'GPS',
  ELECTRICITY = 'ELECTRICMETEROPTICALREADER',
  GAS = 'GASMETEROPTICALREADER',
  HEAT = 'HEAT',
  WATER = 'WATER',
  DOGTOILET = 'DOGTOILET',
  SOILMOISTURE = 'SOILMOISTURESENSOR',
}

export enum DeviceCategory {
  meter = 'M',
  sensor = 'S',
}

export enum SensorOnboardingMode {
  new = 'NEW',
  replacement = 'REPLACEMENT',
  meter = 'METER',
}

export enum SpeedSensorCarTypes {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
  HUGE = 'HUGE',
  ALLSIZES = 'ALLSIZES',
}

export enum SpeedSensorCarDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
  ALLDIRECTIONS = 'ALLDIRECTIONS',
}

export enum SpeedSensorClassification {
  SPEED_LIMIT = 'SPEED_LIMIT',
  DIRECTION = 'DIRECTION',
  CAR_SIZE = 'CAR_SIZE',
}

export enum SensorClassification {
  NONE = 'NONE',
}

export enum GasSensorClassification {
  ESTIMATED = 'ESTIMATED',
  CALCULATED = 'RAW',
}

export enum CommonUnits {
  cubicMeter = 'm³',
  kWh = 'kWh',
  count = 'count',
  anzahl = 'Anzahl',
}

export enum TankForm {
  BULLET = 'BULLET',
  CYLINDER_HORIZONTAL = 'CYLINDER_HORIZONTAL',
  CYLINDER_VERTICAL = 'CYLINDER_VERTICAL',
  OVAL_HORIZONTAL = 'OVAL_HORIZONTAL',
  OVAL_VERTICAL = 'OVAL_VERTICAL',
  RECTANGLE = 'RECTANGLE',
}

export enum TankDimensionMeasurement {
  LENGTH = 'LENGTH',
  WIDTH = 'WIDTH',
  HEIGHT = 'HEIGHT',
  DIAMETER_A = 'DIAMETER_A',
  DIAMETER_D = 'DIAMETER_D',
}

export enum SensorDataChartTypes {
  fifteenMinute = 'Viertelstundenwerte',
  hourly = 'Stundenwerte',
  weekly = 'Tageswerte (Woche)',
  daily = 'Tageswerte (Monat)',
  yearly = 'Jahreswerte',
  monthly = 'Monatswerte',
  slpPeriodic = 'Periodisch',
  daysAWeek = 'Wochen',
}

export enum GranularityRate {
  min15 = 'FIFTEEN_MIN',
  hourly = 'HOURLY',
  daily = 'DAILY',
  monthly = 'MONTHLY',
  yearly = 'YEARLY',
}

export enum SpanViewGranularityRate {
  min15 = 'min15',
  hourly = 'hourly',
  daily = 'daily',
  monthly = 'monthly',
  yearly = 'yearly',
}

export enum MeterTypeDirection {
  consumption = 'Bezug',
  generation = 'Einspeisung',
}

export enum MeterReadingType {
  CSC = 'CSC',
  SPACE = 'SPACE',
}

export enum RegionTypeEnum {
  backOfficeRegion = 'BOR',
  serviceRegion = 'SR',
  adminAreaRegion = 'AM',
  kamRegion = 'SKR',
  customerServiceRegion = 'CSR',
  poHoldingRegion = 'POHOLR',
}

export enum MeterClassification {
  consumer = 'Verbraucher',
  producer = 'Erzeuger',
}

export enum MeterConsumptionGranularityTypes {
  fifteenMinute = 'Viertelstundenwerte',
  hourly = 'Stundenwerte',
  weekly = 'Tageswerte (Woche)',
  daily = 'Tageswerte (Monat)',
  monthly = 'Monatswerte',
  yearly = 'Jahreswerte',
  periodic = 'Abrechnungszeitraum',
  // AbsoluteReading = 'Absoluter Zählerstand'
}

export enum EfficiencyAnalysisColorStatus {
  efficient = '#61C454',
  midEfficient = '#F5C050',
  inefficient = '#ED6A5E',
}

export enum EfficiencyAnalysisElectricityMeterConfig {
  multiple = 'ELECTRICITY_MULTIPLE',
  none = 'NO_ELECTRICITY',
  single = 'ELECTRICITY_SINGLE',
}

export enum IdpName {
  CIAM = 'CIAM',
  AAD = 'AAD',
}

export enum ProducerEnergyTypes {
  PHOTOVOLTAICS = 'Photovoltaik',
  BIOMASS = 'Biomasse',
  WATER = 'Wasser',
  WIND = 'Wind',
}

export enum ProducerEnergyTypeCodes {
  PHOTOVOLTAICS = 'PRD-PV',
  BIOMASS = 'PRD-BIOMASS',
  WATER = 'PRD-WATER',
  WIND = 'PRD-WIND',
}

export enum TariffClassifications {
  HT = 'Hochtarif',
  NT = 'Niedertarif',
  ET = 'Eintarif',
}

export enum ProducerInstallationType {
  Z01 = 'Erzeugte Energie',
  Z02 = 'Eigenverbrauch',
  Z01Z02 = 'Eingespeiste Energie',
}

export enum InstallationTypes {
  Z01 = 'Z01',
  Z02 = 'Z02',
  Z06 = 'Z06',
  Z07 = 'Z07',
  Z12 = '012',
  Z24 = '024',
}

export enum RegisterTypes {
  HT = 'HT',
  NT = 'NT',
  ET = 'ET',
  EINSPEISUNG = 'Einspeisung',
}

export enum RateTypes {
  EZH = 'EZH',
  EZN = 'EZN',
}

export enum Tenant {
  BAYERNWERK = 'bag',
  AVACON = 'ava',
  SHNETZ = 'shn',
  ELBENERGIE = 'elb',
  LECHWERKE = 'lew',
  ENVIAM = 'envm',
  WESTENERGIE = 'wee',
  SUWAG = 'swg',
  EDIS = 'edis',
}

export enum GemisTenant {
  ENVIAM = 'envm',
  WESTENERGIE = 'wee',
  EDIS = 'edis',
  SUWAG = 'swg',
}

export enum NonGemisTenantWithCustomEmailSending {
  BAYERNWERK = 'bag',
  SHNETZ = 'shn',
}

export enum PrivilegeAccess {
  YES = 'Ja',
  NO = 'Nein',
}

export enum DownloadMeterReadings {
  mandatoryMeters = 'Nur ablesepflichtige Zähler',
  allMeters = 'Alle Zähler',
}

export enum FilterOptionTypes {
  MSB = 'MSBs',
  ENERGY = 'EnergyTypes',
  METER = 'MeterTypes',
}

export enum MsbCategories {
  GMSB = 'gMSB',
  WMSB = 'wMSB',
}

export enum PermissionCode {
  ANTRAEGE = 'ANTRAEGE',
  ANNUAL_READING_VALUES = 'ANNUAL_READING_VALUES',
  CO2_BALANCE_SHEET_LINK = 'CO2_BALANCE_SHEET_LINK',
  CONTACT = 'CONTACT',
  EFFICIENCY_ANALYSIS = 'EFFICIENCY_ANALYSIS',
  ENERGIE_MANAGEMENT_OPTIMUM = 'ENERGIE_MANAGEMENT_OPTIMUM',
  ENERGY_MAP = 'ENERGY_MAP',
  ENERGY_MONITOR = 'ENERGY_MONITOR',
  INFORMATION = 'INFORMATION',
  INNO_LIVE = 'INNO_LIVE',
  LOCAL_ELECTRICITY_MARKET_LINK = 'LOCAL_ELECTRICITY_MARKET_LINK',
  PRODUCT_CATALOGUE = 'PRODUCT_CATALOGUE',
  ROOM_MONITORING = 'ROOM_MONITORING',
  ROOM_MONITORING_EDITOR = 'ROOM_MONITORING_EDITOR',
  SENSOR_DATA = 'SENSOR_DATA',
  SENSOR_ONBOARDING = 'SENSOR_ONBOARDING',
  SENSOR_TEASER_EDITOR = 'SENSOR_TEASER_EDITOR',
  SOCKET_SERVICE = 'SOCKET_SERVICE',
  STREETLIGHT_PLANNER = 'STREETLIGHT_PLANNER',
  STORUNGEN = 'STORUNGEN',
  WARMEDATEN = 'WARMEDATEN',
  ENERGY_REPORT = 'ENERGY_REPORT',
  ENERGY_GUARD = 'ENERGY_GUARD',
  FINANCE_REPORT = 'FINANCE_REPORT',
  GRID_INFRA = 'GRID_INFRA',
  ENERGIEDATEN = 'ENERGY_DATA',
  SERVICES = 'SERVICES',
  ZAHLERSTAND_V3 = 'METER_READING_SPACE',
}

export enum MunicipalityKey {
  SCHWANDORF = '09376161',
}

export enum ObisIdCategories {
  '1.8.0' = 'Zählerstand, Netzbezug, Eintarif (ET)',
  '1.8.1' = 'Zählerstand, Netzbezug, Hochtarif (HT)',
  '1.8.2' = 'Zählerstand, Netzbezug, Niedertarif (NT)',
  '2.8.0' = 'Zählerstand, Netzeinspeisung',
  '3.0.0' = 'Zählerstand, Netzbezug Gas',
  '3.1.0' = 'Zählerstand, Netzbezug Gas (temperaturkompensiert)',
}

export enum MeasurementTypes {
  binary = 'binary',
}

export enum CommonTerms {
  sensor = 'SENSOR',
  meter = 'METER',
  temporary = 'TEMPORARY',
}

export enum KeyboardEvents {
  enter = 'Enter',
  spacebar = 'Spacebar',
}

export enum ErrorName {
  timeoutError = 'timeouterror',
}

export enum MeterDownloadWizardSelection {
  current = 'current',
  multiple = 'multiple',
}

export enum NScaleStatus {
  success = 'success',
  error = 'error',
}

export enum ActionType {
  create = 'Create',
  update = 'Update',
  delete = 'Delete',
}

export enum TooltipPosition {
  ABOVE = 'above',
  BELOW = 'below',
  LEFT = 'left',
  RIGHT = 'right',
  DEFAULT = 'above',
}

export enum HeatDataFileRequestStatus {
  COMPLETED = 'Completed',
  PENDING = 'Pending',
  FAIL = 'Fail',
}

export enum ExcelSheetName {
  Kommunenuebersicht = 'Kommunenuebersicht',
  ExterneApp = 'Externe Apps',
}

export enum MeterExcelDownloadOptions {
  HISTORIC_METERS = 'Alle Zähler mit Zählerstandhistorie',
  ALL_METERS = 'Alle Zähler mit letzter Ablesung',
  MANDATORY_METERS = 'Nur ablesepflichtige Zähler',
}

export enum MetersDataType {
  HISTORIC_METERS = 'historicMeters',
  ALL_METERS = 'allMeters',
}

export enum NotificationStatus {
  ACTIVE = 'aktiv',
  INACTIVE = 'nicht aktiv',
  NOT_SPECIFIED = 'Keine Angabe möglich',
}

export enum MaintenanceTypes {
  PLANNED = 'PLANNED_EVENT',
  UNPLANNED = 'UNPLANNED_EVENT',
}
